import React, { useRef } from 'react';
import { RefObject } from 'react';
import styles from './case-listing-tile-container.scss';

export interface PortalTargetContextType {
  portalTarget?: RefObject<HTMLDivElement> | null;
}

export const PortalTargetContext = React.createContext<PortalTargetContextType>({
  portalTarget: null
});

export const PortalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const portalTarget = useRef<HTMLDivElement>(null);
  return (
    <PortalTargetContext.Provider value={{ portalTarget }}>
      <div ref={portalTarget} className={styles.portalTarget}>
        {children}
      </div>
    </PortalTargetContext.Provider>
  );
};
